import { render, staticRenderFns } from "./Part-Environment.vue?vue&type=template&id=6c8fccde"
import script from "./Part-Environment.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-Environment.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8fccde')) {
      api.createRecord('6c8fccde', component.options)
    } else {
      api.reload('6c8fccde', component.options)
    }
    module.hot.accept("./Part-Environment.vue?vue&type=template&id=6c8fccde", function () {
      api.rerender('6c8fccde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tables/formats/Part-Environment.vue"
export default component.exports